import { motion } from "framer-motion";

const chapters = [
  { n: "01", title: "Browse & pick your gear", body: "Explore our full inventory of bouncers, tents, tables and extras. Add everything you need to your booking in a couple of taps." },
  { n: "02", title: "Choose your date", body: "Select your event date and how many days you need each item. We check availability instantly so there are no surprises." },
  { n: "03", title: "Pay a small deposit", body: "Lock in your booking with a secure 30% deposit via Stripe. The balance is due on delivery day — simple and transparent." },
  { n: "04", title: "We deliver & set up", body: "Our crew arrives, sets everything up safely, and picks it all back up when the party's over. You just enjoy the day." },
];

export default function Manifesto() {
  return (
    <section id="how" className="relative py-24 md:py-32 bg-ink text-cream">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-2xl mb-16">
          <span className="text-sm font-700 uppercase tracking-widest text-brand-yellow">How It Works</span>
          <h2 className="mt-3 font-display font-900 tracking-tight text-4xl md:text-6xl leading-none">
            From wishlist to <span className="text-brand-coral">celebration</span> in four steps.
          </h2>
        </div>

        <div className="grid md:grid-cols-[0.4fr_1fr] gap-x-12">
          <div className="hidden md:block">
            <div className="sticky top-28">
              <div className="font-display font-900 text-[9rem] leading-none text-white/10">04</div>
              <p className="text-cream/50 font-500 max-w-[16rem]">
                No hidden fees. No stress. Just a party that runs itself.
              </p>
            </div>
          </div>

          <div className="space-y-14">
            {chapters.map((c, i) => (
              <motion.div
                key={c.n}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.05, ease: [0.76, 0, 0.24, 1] }}
                className="flex gap-6 border-b border-white/10 pb-12"
                data-testid={`manifesto-${c.n}`}
              >
                <div className="font-display font-900 text-4xl md:text-5xl text-brand-coral shrink-0 w-20">{c.n}</div>
                <div>
                  <h3 className="font-display font-800 text-2xl md:text-3xl tracking-tight">{c.title}</h3>
                  <p className="mt-2 text-cream/60 font-500 text-lg leading-relaxed">{c.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
